
import * as z from "zod";

export const formSchema = z.object({
  student_id: z.string().min(1, "Selecione um aluno"),
  assessment_date: z.date(),
  weight: z.string().optional(),
  body_fat_percentage: z.string().optional(),
  muscle_mass: z.string().optional(),
  chest_measurement: z.string().optional(),
  waist_measurement: z.string().optional(),
  hip_measurement: z.string().optional(),
  arm_measurement: z.string().optional(),
  thigh_measurement: z.string().optional(),
  blood_pressure: z.string().optional(),
  resting_heart_rate: z.string().optional(),
  observations: z.string().optional(),
});

export type FormValues = z.infer<typeof formSchema>;
